import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33b3d81b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "oc_detail"
}
const _hoisted_2 = { style: {"padding":"13px 15px"} }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "time" }
const _hoisted_5 = { class: "time_p" }
const _hoisted_6 = { class: "date_p" }
const _hoisted_7 = { class: "step_circle" }
const _hoisted_8 = { class: "arrow" }
const _hoisted_9 = { class: "code" }
const _hoisted_10 = { class: "shop_name" }
const _hoisted_11 = { class: "shop_code" }
const _hoisted_12 = { class: "shop_code" }
const _hoisted_13 = { class: "shop_code" }
const _hoisted_14 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_reject_delay_apply = _resolveComponent("reject-delay-apply")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.storeInfo.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, "状态：" + _toDisplayString($setup.storeInfo.data.state_name), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "step",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.OPERATION_RECORD,
            query: {
              id: $setup.storeInfo.data.id
            }
          })
        ))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString($setup.moment(Number($setup.storeInfo.data.opt_info?.create_time) * 1000).format("hh:mm")), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString($setup.moment(Number($setup.storeInfo.data.opt_info?.create_time) * 1000).format("YY-MM-DD")), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_van_steps, {
                  direction: "vertical",
                  active: "0",
                  "active-icon": "circle",
                  "active-color": "#3d6eeb"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_step, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, [
                          _createTextVNode(_toDisplayString($setup.storeInfo.data.opt_info?.user_info?.name) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString($setup.storeInfo.data.opt_info?.log), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_step)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_van_icon, { name: "arrow" })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString($setup.storeInfo.data.title) + _toDisplayString($setup.storeInfo.data.oc_type_name), 1),
              _createElementVNode("div", _hoisted_11, "申请延期至：" + _toDisplayString($setup.storeInfo.data.date_end), 1),
              _createElementVNode("div", _hoisted_12, "延期原因：" + _toDisplayString($setup.storeInfo.data.delay_reason_name), 1),
              _createElementVNode("div", _hoisted_13, "备注：" + _toDisplayString($setup.storeInfo.data.desc), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.data.opt_lists, (opt, index) => {
              return (_openBlock(), _createBlock(_component_van_button, {
                style: _normalizeStyle({ marginRight: index === 0 ? '10px' : '' }),
                key: opt.type,
                plain: opt.type == 6,
                type: "primary",
                block: "",
                onClick: ($event: any) => ($setup.optClick(opt.type))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(opt.name), 1)
                ]),
                _: 2
              }, 1032, ["style", "plain", "onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_reject_delay_apply, {
      show: $setup.rejectDelayApplyInfo.show,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.rejectDelayApplyInfo.show) = $event)),
      onSubmit: $setup.rejectDelayApplyInfo.onSubmit
    }, null, 8, ["show", "onSubmit"])
  ], 64))
}